export const GET_PS_SOIP='home/systemcharts/GET_PS_SOIP';
export const SET_PS_SOIP='home/systemcharts/SET_PS_SOIP';

